(function () {
  'use strict';

  var STORAGE_KEY = 'eim_shown_at';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function getFrequencyTTL(frequency) {
    switch (frequency) {
      case 'day':     return 24 * 60 * 60 * 1000;
      case 'week':    return 7 * 24 * 60 * 60 * 1000;
      case 'session': return null;
      case 'always':  return 0;
      default:        return null;
    }
  }

  function shouldShow(frequency) {
    if (frequency === 'always') return true;

    if (frequency === 'session') {
      return !sessionStorage.getItem(STORAGE_KEY);
    }

    var last = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);
    if (!last) return true;
    var ttl = getFrequencyTTL(frequency);
    return (Date.now() - last) > ttl;
  }

  function markShown(frequency) {
    if (frequency === 'session') {
      sessionStorage.setItem(STORAGE_KEY, String(Date.now()));
    } else {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    }
  }

  function initModal(modal) {
    var frequency = modal.dataset.frequency || 'session';
    var minSeconds = parseInt(modal.dataset.minSeconds || '5', 10);
    var sensitivity = modal.dataset.sensitivity || 'medium';
    var disableMobile = modal.dataset.disableMobile === 'true';
    var isMobile = window.matchMedia('(max-width: 749px)').matches || !window.matchMedia('(hover: hover)').matches;

    if (disableMobile && isMobile) return;
    if (!shouldShow(frequency)) return;

    var loadTime = Date.now();
    var hasTriggered = false;
    var closeButtons = modal.querySelectorAll('[data-eim-close]');
    var copyButton = modal.querySelector('[data-eim-copy]');
    var cta = modal.querySelector('.exit-intent-modal__cta');
    var previouslyFocused = null;

    function open() {
      if (hasTriggered) return;
      /* Don't stack on top of another open popup (countdown, chat, cart drawer…).
         Stay armed so we can fire later once the other popup closes. */
      if (window.FMEPopups && !window.FMEPopups.canOpen('exit-intent')) return;
      hasTriggered = true;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
      if (window.FMEPopups) window.FMEPopups.markOpen('exit-intent');
      previouslyFocused = document.activeElement;
      var focusTarget = cta || modal.querySelector('.exit-intent-modal__close');
      if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 100);
      markShown(frequency);
      teardownTriggers();
    }

    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
      if (window.FMEPopups) window.FMEPopups.markClose('exit-intent');
      if (previouslyFocused && previouslyFocused.focus) previouslyFocused.focus();
    }

    /* Desktop: cursor leaves viewport from the top */
    function onMouseLeave(e) {
      if (Date.now() - loadTime < minSeconds * 1000) return;
      if (e.relatedTarget || e.toElement) return;

      var threshold = 0;
      if (sensitivity === 'low') threshold = -10;
      else if (sensitivity === 'high') threshold = 30;

      if (e.clientY <= threshold) open();
    }

    /* Mobile: fast scroll-up after significant scroll depth */
    var lastScrollY = window.scrollY;
    var lastScrollTime = Date.now();
    var maxScroll = 0;

    function onScroll() {
      var now = Date.now();
      var currentY = window.scrollY;
      maxScroll = Math.max(maxScroll, currentY);

      if (now - loadTime < minSeconds * 1000) {
        lastScrollY = currentY;
        lastScrollTime = now;
        return;
      }

      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      var scrolledEnough = maxScroll / Math.max(docHeight, 1) > 0.25;
      var deltaY = lastScrollY - currentY;
      var deltaTime = now - lastScrollTime;
      var velocity = deltaY / Math.max(deltaTime, 1);

      /* Scrolling up (deltaY > 0) fast AND near top of page */
      if (scrolledEnough && velocity > 1.5 && currentY < window.innerHeight * 0.5) {
        open();
      }

      lastScrollY = currentY;
      lastScrollTime = now;
    }

    /* Mobile fallback: page visibility change (tab switch) */
    function onVisibilityChange() {
      if (document.visibilityState === 'hidden') {
        /* Mark shown so it does not instantly reappear; trigger on next interaction */
      }
    }

    function onKeyDown(e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    }

    function teardownTriggers() {
      document.removeEventListener('mouseleave', onMouseLeave);
      document.removeEventListener('mouseout', onMouseLeave);
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    }

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', close);
    });

    document.addEventListener('keydown', onKeyDown);

    if (copyButton) {
      copyButton.addEventListener('click', function () {
        var code = copyButton.getAttribute('data-eim-copy');
        if (!code) return;
        var originalLabel = copyButton.querySelector('.exit-intent-modal__code-copy-label');
        var originalText = originalLabel ? originalLabel.textContent : 'Copy';
        var done = function () {
          copyButton.classList.add('is-copied');
          if (originalLabel) originalLabel.textContent = 'Copied';
          setTimeout(function () {
            copyButton.classList.remove('is-copied');
            if (originalLabel) originalLabel.textContent = originalText;
          }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else {
          var ta = document.createElement('textarea');
          ta.value = code;
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(ta);
          done();
        }
      });
    }

    if (isMobile) {
      window.addEventListener('scroll', onScroll, { passive: true });
      document.addEventListener('visibilitychange', onVisibilityChange);
    } else {
      document.addEventListener('mouseleave', onMouseLeave);
    }
  }

  ready(function () {
    document.querySelectorAll('[data-exit-intent]').forEach(initModal);
  });

  document.addEventListener('shopify:section:load', function (e) {
    var modal = e.target.querySelector('[data-exit-intent]');
    if (modal) initModal(modal);
  });
})();
